export default __webpack_public_path__ + "static/media/MongoDB.694e8309.svg";